<script setup lang="ts">
  const NAVIGATION_STORE = useNavigationStore();
  const { session } = storeToRefs(useAuthStore());
  setTimeout(
    () => NAVIGATION_STORE.navigateBySessionStatus(),
    session.value.authenticated ? 5000 : 0,
  );
</script>

<template>
  <splash-screen v-if="session.authenticated" />
</template>

<route lang="yaml">
name: index
meta:
  layout: clear
  isAuthRequired: false
</route>
